export default "__VITE_ASSET__DUqYIDze__"